export interface BannerSlide {
  eyebrow: string;
  title: string;
  desc: string;
  primaryLabel: string;
  primaryTo: string;
  secondaryLabel: string;
  secondaryTo: string;
  image: string;
}

export const bannerSlides: BannerSlide[] = [
  {
    eyebrow: "今日招牌推荐",
    title: "牛骨慢炖三小时，只为这一碗热汤面",
    desc: "精选澳洲牛腩与手打小麦面，配上浓郁红烧汤底，从厨房到你家平均仅需 32 分钟。",
    primaryLabel: "立即订餐",
    primaryTo: "/food-category",
    secondaryLabel: "查看详情",
    secondaryTo: "/food-detail/beef-noodle",
    image:
      "https://readdy.ai/api/search-image?query=warm%20cozy%20close%20up%20of%20a%20steaming%20bowl%20of%20braised%20beef%20noodle%20soup%20on%20a%20rustic%20wooden%20table%2C%20soft%20golden%20afternoon%20light%2C%20steam%20rising%2C%20warm%20amber%20and%20brown%20tones%2C%20cinematic%20editorial%20food%20photography%2C%20rich%20and%20appetizing%2C%20high%20detail&width=1600&height=900&seq=home-banner-01&orientation=landscape",
  },
  {
    eyebrow: "快递服务上线",
    title: "同城最快 30 分钟送达，热食到手还冒热气",
    desc: "智能调度就近派单，全程冷链保温箱，生鲜、药品、文件都能寄，丢损必赔。",
    primaryLabel: "立即寄件",
    primaryTo: "/courier-send",
    secondaryLabel: "查询快递",
    secondaryTo: "/courier-track",
    image:
      "https://readdy.ai/api/search-image?query=delivery%20courier%20on%20a%20scooter%20with%20an%20insulated%20food%20bag%20speeding%20through%20a%20warm%20sunlit%20city%20street%2C%20motion%20blur%2C%20orange%20and%20amber%20tones%2C%20dynamic%20editorial%20photography%2C%20cinematic%20lighting%2C%20high%20detail&width=1600&height=900&seq=home-banner-02&orientation=landscape",
  },
  {
    eyebrow: "限时尝鲜",
    title: "秋日限定桂花拿铁，第二杯半价",
    desc: "十二小时冷萃咖啡遇上现熬桂花糖浆，顺滑清甜，活动期间到店自取免配送费。",
    primaryLabel: "立即订餐",
    primaryTo: "/food-category",
    secondaryLabel: "看看甜点",
    secondaryTo: "/food-detail/matcha-mille",
    image:
      "https://readdy.ai/api/search-image?query=glass%20of%20iced%20osmanthus%20latte%20with%20milk%20swirl%20and%20tiny%20yellow%20flowers%20on%20a%20warm%20wooden%20table%2C%20soft%20golden%20light%2C%20warm%20cream%20and%20amber%20tones%2C%20cinematic%20editorial%20drink%20photography%2C%20high%20detail&width=1600&height=900&seq=home-banner-03&orientation=landscape",
  },
];

export interface SiteStat {
  value: string;
  label: string;
}

export const siteStats: SiteStat[] = [
  { value: "128 万+", label: "累计服务用户" },
  { value: "120+", label: "覆盖配送片区" },
  { value: "30 分钟", label: "平均送达时效" },
  { value: "4.9 分", label: "用户综合评分" },
];

export interface HighlightItem {
  icon: string;
  title: string;
  desc: string;
}

export const foodHighlights: HighlightItem[] = [
  { icon: "ri-restaurant-2-line", title: "严选商家", desc: "只与持证餐厅合作，每季度抽检卫生与食材来源" },
  { icon: "ri-timer-flash-line", title: "极速出餐", desc: "热食冷链保温箱配送，从出锅到送达不超 40 分钟" },
  { icon: "ri-price-tag-3-line", title: "价格透明", desc: "明码标价、分量实在，新客首单立减 15 元" },
];

export interface PromotionItem {
  tag: string;
  title: string;
  desc: string;
  code: string;
  image: string;
}

export const promotions: PromotionItem[] = [
  {
    tag: "新客专享",
    title: "首单立减 15 元",
    desc: "新用户注册下单即可领取，全场美食通用，有效期 7 天。",
    code: "NEW15",
    image:
      "https://readdy.ai/api/search-image?query=warm%20flat%20lay%20of%20various%20asian%20takeout%20dishes%20in%20kraft%20boxes%20on%20a%20cream%20linen%20surface%2C%20soft%20natural%20light%2C%20orange%20and%20amber%20accents%2C%20editorial%20food%20photography%2C%20high%20detail&width=800&height=600&seq=home-promo-01&orientation=landscape",
  },
  {
    tag: "限时活动",
    title: "满 68 元免配送费",
    desc: "每日 11:00-13:00 与 17:00-19:00 下单，满 68 元自动免配送费。",
    code: "FREESHIP",
    image:
      "https://readdy.ai/api/search-image?query=colorful%20takeout%20delivery%20boxes%20stacked%20with%20a%20courier%20bag%20nearby%20on%20a%20warm%20beige%20background%2C%20soft%20natural%20light%2C%20cheerful%20and%20clean%2C%20editorial%20photography%2C%20high%20detail&width=800&height=600&seq=home-promo-02&orientation=landscape",
  },
  {
    tag: "会员日",
    title: "周三会员日全场 8 折",
    desc: "每周三会员下单享 8 折优惠，可与优惠券叠加使用，次数不限。",
    code: "WED20",
    image:
      "https://readdy.ai/api/search-image?query=hand%20holding%20a%20discount%20coupon%20over%20a%20spread%20of%20warm%20colored%20desserts%20on%20a%20cream%20surface%2C%20soft%20natural%20light%2C%20warm%20orange%20accents%2C%20editorial%20food%20photography%2C%20high%20detail&width=800&height=600&seq=home-promo-03&orientation=landscape",
  },
];

export interface Testimonial {
  name: string;
  role: string;
  avatar: string;
  content: string;
  rating: number;
}

export const testimonials: Testimonial[] = [
  {
    name: "王一诺",
    role: "产品经理",
    avatar:
      "https://readdy.ai/api/search-image?query=portrait%20headshot%20of%20a%20confident%20young%20chinese%20professional%20smiling%2C%20clean%20warm%20neutral%20background%2C%20soft%20studio%20lighting%2C%20natural%20and%20friendly%2C%20high%20detail&width=200&height=200&seq=home-user-01&orientation=squarish",
    content: "加班到很晚点一碗牛肉面，28 分钟就到了，汤还是烫的。配送员态度也特别好，已经是我的深夜固定选择。",
    rating: 5,
  },
  {
    name: "赵欣然",
    role: "大学老师",
    avatar:
      "https://readdy.ai/api/search-image?query=portrait%20headshot%20of%20a%20gentle%20chinese%20woman%20with%20short%20hair%20smiling%2C%20clean%20warm%20neutral%20background%2C%20soft%20studio%20lighting%2C%20natural%20and%20kind%2C%20high%20detail&width=200&height=200&seq=home-user-02&orientation=squarish",
    content: "给爸妈点了几次甜点和水果，包装很干净，配送也快。老人家说比自己去买还省事，特别满意。",
    rating: 5,
  },
  {
    name: "刘子豪",
    role: "创业者",
    avatar:
      "https://readdy.ai/api/search-image?query=portrait%20headshot%20of%20a%20cheerful%20chinese%20young%20man%20smiling%2C%20clean%20warm%20neutral%20background%2C%20soft%20studio%20lighting%2C%20energetic%20and%20friendly%2C%20high%20detail&width=200&height=200&seq=home-user-03&orientation=squarish",
    content: "团队下午茶全靠它，一次几十份也能准时送到，还能开发票。行政省了一大半的事，真心推荐。",
    rating: 5,
  },
];

export interface TimelineItem {
  year: string;
  title: string;
  desc: string;
}

export const aboutTimeline: TimelineItem[] = [
  { year: "2019", title: "品牌诞生", desc: "三个热爱美食的年轻人从一间 30 平米的小厨房出发，上线第一款自营牛肉面。" },
  { year: "2021", title: "开启快递业务", desc: "自建同城配送团队，骑手规模突破 500 人，实现主城区 45 分钟送达。" },
  { year: "2023", title: "平台化升级", desc: "接入 800+ 严选商家，推出「美味的快递」App，服务用户突破 60 万。" },
  { year: "2025", title: "全城覆盖", desc: "覆盖 120+ 配送片区，日均订单突破 20 万单，用户综合评分稳定在 4.9 分。" },
];

export interface TeamMember {
  name: string;
  role: string;
  avatar: string;
}

export const teamMembers: TeamMember[] = [
  {
    name: "周明轩",
    role: "创始人 & CEO",
    avatar:
      "https://readdy.ai/api/search-image?query=professional%20portrait%20of%20a%20chinese%20male%20founder%20in%20a%20smart%20casual%20shirt%20smiling%20warmly%2C%20clean%20warm%20beige%20background%2C%20soft%20studio%20lighting%2C%20confident%20and%20approachable%2C%20high%20detail&width=400&height=400&seq=about-team-01&orientation=squarish",
  },
  {
    name: "陈思远",
    role: "联合创始人 & 运营负责人",
    avatar:
      "https://readdy.ai/api/search-image?query=professional%20portrait%20of%20a%20chinese%20woman%20in%20a%20light%20blazer%20smiling%2C%20clean%20warm%20beige%20background%2C%20soft%20studio%20lighting%2C%20confident%20and%20friendly%2C%20high%20detail&width=400&height=400&seq=about-team-02&orientation=squarish",
  },
  {
    name: "林浩",
    role: "配送网络负责人",
    avatar:
      "https://readdy.ai/api/search-image?query=professional%20portrait%20of%20a%20young%20chinese%20man%20in%20a%20casual%20polo%20smiling%2C%20clean%20warm%20beige%20background%2C%20soft%20studio%20lighting%2C%20energetic%20and%20friendly%2C%20high%20detail&width=400&height=400&seq=about-team-03&orientation=squarish",
  },
  {
    name: "苏晚",
    role: "品牌与品控总监",
    avatar:
      "https://readdy.ai/api/search-image?query=professional%20portrait%20of%20a%20chinese%20woman%20with%20long%20hair%20smiling%20gently%2C%20clean%20warm%20beige%20background%2C%20soft%20studio%20lighting%2C%20elegant%20and%20warm%2C%20high%20detail&width=400&height=400&seq=about-team-04&orientation=squarish",
  },
];

export interface TouchPoint {
  icon: string;
  label: string;
  value: string;
}

export const contactInfo: TouchPoint[] = [
  { icon: "ri-phone-line", label: "服务热线", value: "400-880-1234（7×24 小时）" },
  { icon: "ri-mail-line", label: "邮箱地址", value: "hello@meiweikuaidi.com" },
  { icon: "ri-map-pin-line", label: "总部地址", value: "北京市朝阳区望京 SOHO 塔 C 座 18 层" },
  { icon: "ri-time-line", label: "营业时间", value: "每日 08:00 - 22:00（配送全天候）" },
];

export const searchServices = [
  { name: "同城急送", desc: "30 分钟送达", to: "/courier-send" },
  { name: "快递查询", desc: "实时物流轨迹", to: "/courier-track" },
  { name: "快递服务", desc: "速度、覆盖与保障", to: "/courier" },
];